import { Check } from "lucide-react";

const items = [
  "Segurança jurídica",
  "Defesa estratégica",
  "Proteção patrimonial",
  "Redução de riscos",
  "Assessoria preventiva",
  "Soluções jurídicas eficientes e personalizadas",
];

export default function ParaQuemAtuamos() {
  return (
    <section id="para-quem-atuamos" className="section bg-brand-soft" data-testid="section-publico">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-5">
          <img
            src="https://images.unsplash.com/photo-1573497019418-b400bb3ab074?auto=format&fit=crop&w=900&q=80"
            alt="Profissionais em reunião estratégica"
            className="w-full h-[460px] object-cover"
          />
        </div>
        <div className="lg:col-span-7">
          <p className="eyebrow text-brand-accent mb-6"><span className="thin-rule" />Público atendido</p>
          <h2 className="font-serif text-brand-primary font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight">
            Para quem <em className="not-italic text-brand-accent">atuamos</em>.
          </h2>
          <p className="mt-6 text-[15px] leading-relaxed text-brand-text/80 max-w-xl">
            Atendemos pessoas físicas e jurídicas que buscam:
          </p>

          <ul className="mt-10 grid sm:grid-cols-2 gap-3">
            {items.map((it) => (
              <li
                key={it}
                className="flex items-start gap-3 bg-white border border-brand-primary/10 p-4 hover:border-brand-accent transition-colors"
              >
                <span className="w-6 h-6 flex items-center justify-center bg-brand-primary text-brand-accent flex-shrink-0">
                  <Check size={14} strokeWidth={2.5} />
                </span>
                <span className="text-[14px] text-brand-primary font-medium">{it}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
